/*
 * View for the landlord list administration screen
 */

define(["marionette", "./template/landlordAdminTemplate.html"], function (
  Marionette,
  LandlordAdminTemplate,
) {
  var LandlordAdminView = {};

  LandlordAdminView.landlordAdminView = Marionette.Layout.extend({
    className: "max-height",
    template: LandlordAdminTemplate,
    triggers: {
      "click #addLandlord": "add:landlord",
    },
    regions: {
      landlordsList: "#allLandlordsList",
    },
  });

  return LandlordAdminView;
});
